import { useState } from "react";

export const useHiddenIdMapState = useState;
export const useIndexedPublishersResponseState = useState;
